export default function(_cell, picklist) {
	if (_cell._editorType === 'bool') {
		if (_cell.bool === true) {
			_cell._filterTag = 'Yes';
			return 'Yes';
		}
		if (_cell.bool === false) {
			_cell._filterTag = 'No';
			return 'No';
		}
		_cell._filterTag = '[unset]';
		return '';
	} else if (_cell._editorType === 'picklist') {
		let html = _cell.key.reduce((_html, key, i) => {
			let display = picklist.wrapper;
			let item = picklist.items.find(item => item.key === key);
			_cell._filterTag = i === 0 ? (item ? item.value || key : key) : _cell._filterTag;
			if (item) {
				display = display.replace('{{value}}', item.value);
			} else {
				display = display.replace('{{value}}', key);
			}
			display = display.replace(
				'{{class}}',
				item ? item.class || picklist.defaultClass : picklist.defaultClass
			);
			display = display.replace(
				'{{icon}}',
				item ? item.icon || picklist.defaultIcon : picklist.defaultIcon
			);
			_html += display;
			return _html;
		}, '');
		if (!_cell._filterTag || _cell._filterTag.trim().length === 0) {
			_cell._filterTag = '[unset]'
		}
		return html;
	} else {
		_cell._filterTag = _cell.filterTag;
		return _cell.value.replace(/\n/g, '</br>');
	}
}
